class GiftPromotionManager {
  constructor(options) {
    this.threshold = options.threshold; 
    // FORZATURA A STRINGA per evitare bug di comparazione (es. 12345 === "12345" -> false)
    this.giftIds = options.giftVariantIds.map(String); 
    this.isProcessing = false;

    this.init();
  }

  init() {
    this.syncGifts();
    this.attachEventListeners();
  }

  attachEventListeners() {
    document.addEventListener('cart:updated', () => this.syncGifts());

    const originalFetch = window.fetch;
    const self = this;
    
    window.fetch = async function(...args) {
      // LOCK 1: Ignoriamo le richieste generate dal nostro stesso script usando un header custom
      if (args[1] && args[1].headers && args[1].headers['X-GWP-Action']) {
        return originalFetch.apply(this, args);
      }

      const response = await originalFetch.apply(this, args);
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

      if (url && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/clear') || url.includes('/cart/update'))) {
        if (!self.isProcessing) {
          setTimeout(() => self.syncGifts(), 300);
        }
      }
      return response;
    };
  }

  async fetchCart() {
    const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
    return await res.json();
  }

  async syncGifts() {
    if (this.isProcessing) return;

    try {
      this.isProcessing = true;
      const cart = await this.fetchCart();

      // Calcola totale escludendo i gift
      const eligibleTotal = cart.items
        .filter(item => !this.giftIds.includes(String(item.variant_id)))
        .reduce((sum, item) => sum + item.final_line_price, 0);

      const qualifies = eligibleTotal >= this.threshold;

      const currentGiftItems = cart.items.filter(item => this.giftIds.includes(String(item.variant_id)));
      const currentGiftIds = currentGiftItems.map(item => String(item.variant_id));

      let uiNeedsRefresh = false;

      if (qualifies) {
        const missingGiftIds = this.giftIds.filter(id => !currentGiftIds.includes(id));
        if (missingGiftIds.length > 0) {
          // Tentiamo l'aggiunta. Se fallisce (es. out of stock), non ricarichiamo la UI.
          const success = await this.addGifts(missingGiftIds);
          if (success) uiNeedsRefresh = true;
        }
      } else {
        if (currentGiftItems.length > 0) {
          const success = await this.removeGifts(currentGiftItems);
          if (success) uiNeedsRefresh = true;
        }
      }

      // Ricarica l'interfaccia SOLO se c'è stata una reale aggiunta/rimozione andata a buon fine
      if (uiNeedsRefresh) {
        this.reloadCartUI();
      }

    } catch (error) {
      console.error('[GWP Promo] Errore critico:', error);
    } finally {
      // LOCK 2: Manteniamo il blocco attivo per mezzo secondo extra per assorbire eventi eco del tema
      setTimeout(() => { this.isProcessing = false; }, 500);
    }
  }

  async addGifts(variantIds) {
    const payload = {
      items: variantIds.map(id => ({
        id: Number(id), // L'API di Shopify vuole il numero nell'add.js
        quantity: 1,
        properties: { _is_gift: 'true' }
      }))
    };

    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'X-GWP-Action': 'true' // Header custom per skippare l'interceptor
        },
        body: JSON.stringify(payload)
      });
      
      // LOCK 3: Se Shopify rifiuta (es. inventario esaurito, variant sbagliato), non restituire true
      if (!res.ok) {
        const err = await res.json();
        console.warn('[GWP Promo] Impossibile aggiungere i regali (forse esauriti o ID errato?):', err);
        return false; 
      }
      return true;
    } catch(e) {
      return false;
    }
  }

  async removeGifts(items) {
    const updates = {};
    items.forEach(item => {
      updates[item.key] = 0;
    });

    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'X-GWP-Action': 'true'
        },
        body: JSON.stringify({ updates })
      });
      return res.ok;
    } catch(e) {
      return false;
    }
  }

  reloadCartUI() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      fetch(`${window.Shopify?.routes?.root || '/'}?section_id=cart-drawer`)
        .then(res => res.text())
        .then(html => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const newDrawer = parsed.querySelector('cart-drawer');
          if (newDrawer) cartDrawer.innerHTML = newDrawer.innerHTML;
        });
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (window.location.pathname.includes('/cart')) {
      // Disabilitiamo il reload forzato per evitare flickering.
      // Se usi la cart page standard di Shopify, ricarichiamo solo quella sezione:
      const cartWrapper = document.getElementById('main-cart-items') || document.querySelector('.cart__items');
      if(cartWrapper) {
          fetch(window.location.href)
            .then(res => res.text())
            .then(html => {
               const parsed = new DOMParser().parseFromString(html, 'text/html');
               const newWrapper = parsed.getElementById('main-cart-items') || parsed.querySelector('.cart__items');
               const newFooter = parsed.getElementById('main-cart-footer');
               if(newWrapper && cartWrapper) cartWrapper.innerHTML = newWrapper.innerHTML;
               
               const cartFooter = document.getElementById('main-cart-footer');
               if(newFooter && cartFooter) cartFooter.innerHTML = newFooter.innerHTML;
            });
      } else {
         window.location.reload();
      }
    }
  }
}

// Inizializzazione
document.addEventListener('DOMContentLoaded', () => {
  new GiftPromotionManager({
    threshold: 2500, // 25€ (2500 centesimi)
    giftVariantIds: [54860410388866, 54860789449090] // <-- Inserisci qui i tuoi Variant ID corretti
  });
});
